import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import simpleReactValidator from 'simple-react-validator';

import BlankState from '../components/BlankState';
import Page from '../components/Page';
import CertificatePreview from '../pages/buy/CertificatePreview';

import { publicVerifyPolicy } from '../actions/policy';

class PolicyVerification extends Component {
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      policy: {
        email: '',
        policy_number: ''
      },
      isSubmitted: false,
      policy_is_loading: false,
      policy_details: {},
      error: false
    };
  }

  onChange = e => {
    const { name, value } = e.target;
    const { policy } = this.state;

    this.setState({
      policy: {
        ...policy,
        [name]: value
      }
    });
  };

  onVerifyPolicy = e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.validator.hideMessages();
      this.setState({
        policy_details: {},
        policy_is_loading: true,
        error: false
      });
      this.props
        .publicVerifyPolicy(this.state.policy)
        .then(response => {
          console.log(response);
          this.setState({
            policy_details: response.value.data,
            policy_is_loading: false,
            error: false
          });
        })
        .catch(error => {
          console.log(error);
          this.setState({
            policy_is_loading: false,
            policy_details: {},
            error: true
          });
        });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { policy_details, policy_is_loading, error } = this.state;
    return (
      <Page pageTitle="Verify Your Policy">
        <div className="clearfix card">
          <div className="col-sm-4">
            <form className="form sign-in" onSubmit={this.onVerifyPolicy}>
              <p className="text-muted">
                Enter the Policy Number and Email Address to verify
              </p>

              <input
                type="text"
                id="policy_number"
                name="policy_number"
                value={this.state.policy.policy_number}
                onChange={this.onChange}
                className="form-control"
                placeholder="Policy Number"
                autoFocus
              />
              {this.validator.message(
                'policy_number',
                this.state.policy.policy_number,
                'required',
                'text-danger'
              )}
              <input
                type="email"
                id="email"
                name="email"
                value={this.state.policy.email}
                onChange={this.onChange}
                className="form-control"
                placeholder="Email Address of Policy Holder"
              />
              {this.validator.message(
                'email',
                this.state.policy.email,
                'required|email',
                'text-danger'
              )}
              <button className="btn btn-warning">
                <i className="icon ion-ios-search-strong" />Verify Policy
              </button>
            </form>
          </div>

          <div className="col-sm-7">
            <BlankState
              data={false}
              customMessage="Verifying policy"
              isDataLoading={policy_is_loading}
            />

            {policy_details.hasOwnProperty('id') ? (
              <div className="clearfix verify-certificate-holder">
                <CertificatePreview quote={policy_details} />
              </div>
            ) : null}

            {error ? (
              <div className="alert alert-danger">
                <i className="icon ion-close" />&nbsp; Verification failed. We
                could not find a policy matching those details
              </div>
            ) : null}
          </div>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ publicVerifyPolicy }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PolicyVerification);



// WEBPACK FOOTER //
// ./src/pages/PolicyVerification.js